import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDeletePatientClaim() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.deletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteMutation(),
    onSuccess: (_, variables) => {
      const queryOptions = apiClient.getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetOptions({
        path: { document_key: variables.path.document_key },
      })

      queryClient.setQueryData(
        queryOptions.queryKey,
        (old: apiClient.PatientClaimsResponse | undefined) => {
          if (!old) return old
          return {
            ...old,
            patient_claims: old.patient_claims.filter((c) => c.key !== variables.path.claim_key),
          }
        },
      )

      queryClient.invalidateQueries(queryOptions)
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: { key: variables.path.document_key },
        }),
      )
    },
  })
}
